module.exports = __webpack_public_path__ + "static/media/machine_circle_arrow.3d54f018.svg";